import React from "react";
import { connect } from "react-redux";
import LoginSignupModal from "./component";

const mapStateToProps = ({
    cmsConfig
}) => ({
    cmsConfig
});
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LoginSignupModal);
